import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import SupportChat from "@/components/SupportChat";
import "@/App.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import CandidateDetail from "@/pages/CandidateDetail";
import TalentPool from "@/pages/TalentPool";
import Actions from "@/pages/Actions";
import CalendarPage from "@/pages/CalendarPage";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/jobs" element={<Jobs />} />
            <Route path="/app/jobs/:jobId" element={<JobDetail />} />
            <Route path="/app/talent" element={<TalentPool />} />
            <Route path="/app/candidates/:candId" element={<CandidateDetail />} />
            <Route path="/app/actions" element={<Actions />} />
            <Route path="/app/calendar" element={<CalendarPage />} />
            <Route path="/app/analytics" element={<Analytics />} />
            <Route path="/app/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <SupportChat />
    </AuthProvider>
  );
}
